// Botón «Copiar» con respaldo (Peaje U-02). Confirma con `role="status"`
// durante 3 s; si el aparato no permite copiar, selecciona el bloque
// visible (`objetivo`, un ref) y lo dice en neutro.
import { useEffect, useRef, useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { copiarTexto, seleccionarContenido, TEXTO_SIN_PORTAPAPELES } from './copiar';

export default function BotonCopiar({ texto, objetivo, etiqueta = 'Copiar', confirmacion = 'Copiado', className = '' }) {
  const [estado, setEstado] = useState(null); // null | 'ok' | 'mano'
  const reloj = useRef(null);
  useEffect(() => () => clearTimeout(reloj.current), []);

  async function copiar() {
    clearTimeout(reloj.current);
    const r = await copiarTexto(texto);
    if (r) {
      setEstado('ok');
      reloj.current = setTimeout(() => setEstado(null), 3000);
    } else {
      seleccionarContenido(objetivo?.current);
      setEstado('mano');
    }
  }

  return (
    <div className="min-w-0">
      <button type="button" onClick={copiar}
              className={`inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-base sm:w-auto ${className}`}>
        {estado === 'ok'
          ? <Check className="h-5 w-5 shrink-0" aria-hidden="true" />
          : <Copy className="h-5 w-5 shrink-0" aria-hidden="true" />}
        {etiqueta}
      </button>
      <p role="status" className="mt-1 text-sm text-gray-700 empty:hidden">
        {estado === 'ok' ? confirmacion : estado === 'mano' ? TEXTO_SIN_PORTAPAPELES : ''}
      </p>
    </div>
  );
}
